import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import moment from 'moment';

import { UnidataTable } from '~/components';
import { number } from '~/helpers';

import {
  recordFiltering,
} from '~/store/modules/telatransmitecentral/actions';

import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';


function TelaTransmiteCentral() {

  const { profile } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const telatransmitecentral = useSelector(
    (state) => state.telatransmitecentral
  );


  const header = useMemo(() => [

    {
      id: 'post_desc',
      label: 'Posto',
    },

    {
      id: 'potr_data_trans',
      label: 'Última Transmissão Central',
      formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      align: 'left',
    },

    {
      id: 'C_tempoDecorrido',
      label: 'Tempo Decorrido',
    },

    {
      id: 'C_StatusLinha',
      label: 'Status Transmissão Central',
      styled: (v) => (v === 'Transmissão Atrasada' ? { color : 'red' } : { color : 'green' }),
    },



    {
      id: 'abas_datahora_fim',
      label: 'Transmissão Cliente',
      formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      align: 'left',
    },

    {
      id: 'transFCAVerm',
      label: 'Status Transmissão Cliente',
      styled: (v) => (v === 'Transmissão Atrasada' ? { color : 'red' } : { color : 'green' }),
    },



  ], []);

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(telatransmitecentral.params));
  }, [telatransmitecentral.params]);

  // Autoload
  React.useEffect(() => {
      const timeOut = setInterval(() => {
        handleUpdate();
      }, 30000);
      return () => clearInterval(timeOut);
  }, []);




  return (
    <>
      <UnidataTable
        create={false}
        delete={false}
        update={false}
        dense
        fixed

        header={header}
        redux={telatransmitecentral}
        read={recordFiltering}
        detach="post_cod_posto"
      />
    </>
  );
}

export default TelaTransmiteCentral;
